import React from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { connect } from 'react-redux';
import moment from 'moment';
import { InView } from 'react-intersection-observer';
import Modal from '../../common/Modal';
import properties from '../../../modules/ajio-util/properties';
import { selectSize } from '../../../actions/productData';
import { generateEvent } from '../../../utils/dataGrinch';
import BrandList from './BrandList';
import Productmodel from './Productmodel.js';
import SelfcareGA from '../../../refresh/templates/SizeGuideTemplate/SizeGuideFooter/SelfcareGA';
import { showModal, hideModal } from '../../../actions/modal';
import ToggleButton from './ToggleButton';
import ToggleButtonIntConv from './ToggleButtonIntConv';
import { gtmPagePush, gtmEventPush, gtmPrimeAICTA, segmentEventPush,getProductItemPDP } from '../../../modules/ga/GTMdatalayer';
import { Feature, Variant } from '../../../refresh/organism/ABFeature';
import {
  getBrandCompare,
  getHowToMeasureVisibleInSizeGuideFlag,
  getHowToMeasureNewImagesFlag,
  getHowToMeasureNewImagesProducts
} from '../../../refresh/selectors/featureFlagsSelector.ts';
import { getFeatureVariant, getVariant } from '../../../refresh/organism/ABFeature/Feature';
import {
  howToMeasureInSizeGuide,
  howToMeasureNewImagesVariation
} from '../../../refresh/constants/experiment.constants';
import screenNames from '../../../refresh/constants/luxeScreenType';
import screen from '../../../refresh/constants/pageType.constant';
import {
  sizeGuideTxt,
  howToMeasureTxt,
  internationalConTxt
} from '../../../refresh/constants/product.constants';
import { replaceFileName } from '../../../refresh/utils/regexUtils';
import {
  getProductCategory,
  getProductSubCategory,
  getBrickName
} from '../../../refresh/selectors/productpage';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


const currentTabs = [sizeGuideTxt, internationalConTxt, howToMeasureTxt];
let hasHowToMeasureObserverCallForTab = false;
const { sizeGuide: { pageType = '', pageName = '' } = {} } = screen;

class SizeGuide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errored: false,
      brand_selected: false,
      targetBrand: '',
      showMenu: false,
      sizeIndex: '',
      showLink: false,
      howToMeasureVisibleInSizeGuid: false,
      howToMeasureObserved: false
    };
    this.brandList = [];
    this.sizeChart = [];
    this.primeAIButton = React.createRef(null);
  }

  componentDidMount() {
    const {
      sizeRecommendationPrimeAILinkFlag = false,
      newDesignLuxe,
      brandCompare = 'OFF'
    } = this.props;
    if (sizeRecommendationPrimeAILinkFlag && !newDesignLuxe) {
      this.handlePrimeAIAddEventListener(0);
      setTimeout(() => {
        this.setState({ showLink: true });
        this.checkPrimeAIWidgetView();
      }, 3000);
    }
  }

  howToMeasureImpression = () => {
    let { productData, newDesignLuxe } = this.props;
    let { code: prodCode = '', name = '' } = productData || {};
    let sizeChart = this.props.sizeGuide;
    let curentBrand = sizeChart.length ? sizeChart[0].BRAND_NAME : '';
    gtmEventPush({
      event: 'size_chart_interactions',
      event_category: 'size chart interactions',
      event_action: 'how to measure impression',
      event_label: `${this.state.howToMeasureVisibleInSizeGuid ? 'bottom' : 'tab'}`,
      page_type: pageType,
      page_name: 'size guide screen',
      product_name: name,
      product_id: prodCode,
      product_brand: curentBrand,
      store_type: newDesignLuxe ? 'luxe' : 'ajio'
    });

    segmentEventPush({
      event: 'Size Chart Interactions',
      event_category: 'size chart interactions',
      //event_action: !inches ? 'in' : 'cm',
      inch_or_cm_flag:  '',
      interaction_description:'how to measure impression',  
      products:[{
          ...getProductItemPDP(this.props?.productData), 
      }], 
      screen_name: 'Size Guide',       
      size_selected_in_radio:''
    });
  };

  componentWillUnmount() {
    const { sizeRecommendationPrimeAILinkFlag = false, newDesignLuxe } = this.props;
    if (sizeRecommendationPrimeAILinkFlag && !newDesignLuxe) {
      this.handlePrimeAIRemoveEventListener();
    }
  }

  handlePrimeAIAddEventListener(value) {
    let that = this;
    if (window.primeaiEmitter) {
      window.primeaiEmitter.addEventListener('continue', function() {
        gtmPrimeAICTA('CONTINUE');
      });

      window.primeaiEmitter.addEventListener('sizerec', function(e) {
        let primeAIGAtype = localStorage.getItem('primeAIGAtype') || 'INIT';
        if (primeAIGAtype === 'INIT') {
          localStorage.setItem('primeAIGAtype', 'EDIT');
        }
        const recommendedSize = e.detail;
        gtmPrimeAICTA('DISPLAY', recommendedSize);
      });
    } else if (value <= 10) {
      setTimeout(() => {
        that.handlePrimeAIAddEventListener(value + 1);
      }, 1000);
    }
  }

  handlePrimeAIRemoveEventListener() {
    if (window.primeaiEmitter) {
      window.primeaiEmitter.removeEventListener('continue', function() {}, false);
      window.primeaiEmitter.removeEventListener('sizerec', function() {}, false);
    }
  }

  handleClick(e) {
    if (this.state.showMenu) {
      this.setState({
        showMenu: false
      });
    }
  }

  handlePrev(e) {
    const parentContainer = document.querySelector('.carousel-mob-container');
    parentContainer.scrollBy(-300, 0);
  }

  handleNext(e) {
    const parentContainer = document.querySelector('.carousel-mob-container');
    parentContainer.scrollBy(300, 0);
  }

  validateSizeStock(stockList) {
    let sizeChart = this.props.sizeGuide;
    let arr = [];
    sizeChart.forEach((el, i) => {
      stockList.forEach((stockEl, j) => {
        if (el.SIZE_NAME === stockEl.value) {
          el.STOCK_LEVEL = stockEl.stockLevel;
        }
      });
    });
    this.sizeChart = sizeChart;
  }

  setBrand = brand => {
    this.setState({
      brand_selected: true,
      targetBrand: brand,
      showMenu: false
    });
  };

  handleError = event => {
    this.setState({ errored: true });
  };

  createBrandList = arrList => {
    let brandList = [];
    let brandName = '';
    if (arrList.length && Object.keys(arrList[0].length > 0)) {
      Object.keys(arrList[0]).forEach(function(val, key) {
        if (
          val.toUpperCase().indexOf('_BRAND') >= 0 &&
          !val.toUpperCase().includes('CURRENT') &&
          val.toUpperCase().indexOf('_CM') === -1 &&
          val.toUpperCase().indexOf('_INCH') === -1
        ) {
          brandList.push(val);
        }
      });
      return brandList;
    }
    return null;
  };

  openBrandList = event => {
    this.setState({
      showMenu: !this.state.showMenu
    });
  };

  closeModal = event => {
    this.props.showModal('size-guide-modal');
    let sizeChart = this.props.sizeGuide;
    let curentBrand = sizeChart.length ? sizeChart[0].BRAND_NAME : '';
    const {
      newDesignLuxe,
      luxeEventPush,
      productData,
      howToMeasureVisibleInSizeGuideFlag,
      app = false
    } = this.props;
    let { code: prodCode = '', name } = productData || {};
    gtmPagePush('size guide screen', pageType, window.__ENV__ || '', {
      product_id: prodCode,
      product_name: name,
      product_brand: curentBrand,
      store: newDesignLuxe ? 'luxe' : 'AJIO'
    });
    let howToMeasureVisibleInSizeGuid = howToMeasureVisibleInSizeGuideFlag
      ? !!(!newDesignLuxe && getVariant(howToMeasureInSizeGuide))
      : false;
    this.setState({
      showMenu: false,
      howToMeasureVisibleInSizeGuid
    });
    if (newDesignLuxe) {
      luxeEventPush({
        eventName: 'size_chart_clicked',
        event_action: 'size chart clicked'
      });
    }
    gtmEventPush({
      event: 'size_chart_interaction',
      event_category: 'size chart interactions',
      event_action: 'Size chart',
      page_type: pageType,
      page_name: 'size guide screen',
      label: 'size chart',
      product_name: name,
      product_id: prodCode,
      store_type: newDesignLuxe ? 'luxe' : 'ajio'
    });
    // Segment Event Push
    segmentEventPush({
      event: 'Size Chart Interactions',
      event_category: 'size chart interactions',
      //event_action: !inches ? 'in' : 'cm',
      inch_or_cm_flag:  '',
      interaction_description:'Close',  
      products:[{
         ...getProductItemPDP(this.props?.productData), 
      }],           
      screen_name: 'size guide screen',       
      size_selected_in_radio:''
    });

    let { sizeRecommendPopUpData } = this.props;
    const singleRecommendVariant = getFeatureVariant('singleRecommend') || '1';
    const recommendedData =
      singleRecommendVariant === '1'
        ? this.singleRecommendData(sizeRecommendPopUpData?.purchasedOrdersData)
        : sizeRecommendPopUpData?.purchasedOrdersData;
    if (recommendedData?.length > 0) {
      let { code: prodCode = '', name = '' } = productData || {};
      const { sizeGuide: { screenName = '', screenType = '' } = {} } = screenNames;
      gtmEventPush({
        event: 'size_chart_interaction',
        event_category: 'purchase recommendations',
        event_action: recommendedData[0]?.recommendedSize || '',
        event_label: '',
        product_id: prodCode,
        product_name: name,
        product_brand: recommendedData[0]?.brandName,
        product_size: recommendedData[0]?.recommendedSize || '',
        page_name: 'size guide screen',
        page_type: screenType
      });
    }
    gtmEventPush({
      event: 'size_chart_interaction',
      event_category: 'size chart interactions',
      event_action: recommendedData?.length > 0 ? 'past purchase shown' : 'past purchase not shown',
      event_label: recommendedData?.length || 0,
      page_type: pageType,
      page_name: 'size guide screen',
      store_type: newDesignLuxe ? 'luxe' : 'ajio'
    });

    gtmEventPush({
      event: 'buttonTap',
      event_category: 'buttonTap',
      event_action: 'size chart interactions',
      event_label: 'Size chart'
    });

   
  };

  selectSize = (event, index) => {
    let Obj = {};
    this.setState({
      sizeIndex: index
    });
    this.props.stockList.forEach(function(val, key) {
      if (val.value === event.target.value) {
        Obj = val;
      }
    });
    let { value, code, stockLevel, stockLevelStatus, discountPrice, originalPrice } = Obj;
    if (stockLevelStatus === 'lowStock') stockLevel = stockLevel;
    else stockLevel = '';
    this.props.selectSize(value, code, stockLevel, discountPrice, originalPrice);
  };

  hideTableColumn = (flag = false, s_value = '') => {
    if (!flag) {
      // flag === OFF
      if (
        s_value.toLowerCase().indexOf('universal size format') === -1 &&
        s_value.toLowerCase().indexOf('brand size format') === -1 &&
        s_value.toLowerCase().indexOf('universal size') === -1
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      // flag === ON
      return true;
    }
  };

  singleRecommendData(recommend = []) {
    if (recommend?.length > 0) {
      if (recommend?.length > 1) {
        const singleData = recommend?.slice(0, 1);
        return singleData;
      } else {
        return recommend;
      }
    } else {
      return [];
    }
  }

  renderData() {
    let sizeChart = this.props.sizeGuide || [];
    let {
      inches,
      defaultUnit,
      newFeatureFlag = true,
      sizeType = '',
      productData,
      sizeRecommendationPrimeAILinkFlag = false,
      newDesignLuxe,
      brandCompare = 'OFF',
      howToMeasureNewImagesFlag,
      howToMeasureNewImagesProducts,
      productCategory,
      productSubCategory,
      brickName
    } = this.props;
    let { code: prodCode = '', name = '' } = productData || {};
    // sizeType = "STANDARD";
    // sizeType = "BRAND";
    // newFeatureFlag = true;
    let { app = false, sizeRecommendPopUpData } = this.props;
    let curentBrand = sizeChart.length ? sizeChart[0].BRAND_NAME : '';
    if (this.props.stockList && this.props.stockList.length) {
      this.validateSizeStock(this.props.stockList);
    }
    this.brandList = this.createBrandList(sizeChart) || [];
    let { targetBrand = '', sizeIndex = '', howToMeasureVisibleInSizeGuid } = this.state;
    let { modelData = [] } = this.props;

    let imageUrl = '';
    if (this.props.image) {
      imageUrl = this.props.image;
    }
    let measurementType;
    let SizeWornByModel;
    let ModelChestSize;
    let ModelHeight;
    let ModelWaistSize;
    let sizeTips;
    let fitType;
    let measureImgUrl;
    let brandLogo;
    let recommendTips;
    let brandTitle;
    let measurementUnit = 'inches';
    let icFlag = false;
    const defaultBlnkText = 'Compare AJIO size with other brands';
    const sizeTable = {
      columns: [],
      rows: []
    };

    const countryTable = {
      columns: [],
      rows: []
    };

    const newImagesProductFilter =
      howToMeasureNewImagesProducts?.length > 0
        ? howToMeasureNewImagesProducts.filter(
            data =>
              data?.brickCategory == productCategory &&
              data?.brickSubCategory == productSubCategory &&
              data?.brickName == brickName
          )
        : [];

    const isShowHowToMeasureNewImages =
      !newDesignLuxe &&
      howToMeasureNewImagesFlag &&
      newImagesProductFilter.length > 0 &&
      getVariant(howToMeasureNewImagesVariation);

    sizeChart.forEach((sizeDetails, index) => {
      const sizeRows = [];
      const icRows = [];
      const brandRows = [];

      if ('HOW_TO_MEASURE_IMAGEURL_1' in sizeDetails && index === 0)
        measureImgUrl = isShowHowToMeasureNewImages
          ? replaceFileName(sizeDetails.HOW_TO_MEASURE_IMAGEURL_1, '_exp')
          : sizeDetails.HOW_TO_MEASURE_IMAGEURL_1;
      if ('TIPS' in sizeDetails && index === 0) sizeTips = sizeDetails.TIPS;
      if ('MEASUREMENT_TYPE' in sizeDetails && index === 0)
        measurementType = sizeDetails.MEASUREMENT_TYPE;
      // if('FITTING_TYPE' in sizeDetails && index === 0) fitType = sizeDetails.FITTING_TYPE;
      if ('BRAND_LOGO' in sizeDetails && index === 0) brandLogo = sizeDetails.BRAND_LOGO;
      // if('SPECIAL_DESC' in sizeDetails && index === 0) recommendTips = sizeDetails.SPECIAL_DESC;

      if (
        'Size_HEADER' in sizeDetails &&
        !sizeTable.columns.includes(sizeDetails.Size_HEADER) &&
        !newFeatureFlag
      ) {
        {
          index === 0 && sizeTable.columns.push(<th key={`h-${index}`}>Size</th>);
        }
        if (!app) {
          sizeRows.push(
            <td
              key={`r-${index}`}
              className={`td-radio ${index === sizeIndex ? 'selected-row' : ''} ${
                sizeDetails.STOCK_LEVEL ? '' : 'disabled'
              }`}
            >
              <label
                className="custom-radio"
                // tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    gtmEventPush({
                      event: 'size_chart_interaction',
                      event_category: 'size chart interactions',
                      event_action: e.target.value,
                      page_type: pageType,
                      page_name: 'size guide screen',
                      product_name: name,
                      product_id: prodCode,
                      store_type: newDesignLuxe ? 'luxe' : 'ajio'
                    });
                    this.selectSize(e, index);
                  }
                }}
              >
                <input
                  onClick={e => {
                    gtmEventPush({
                      event: 'size_chart_interaction',
                      event_category: 'size chart interactions',
                      event_action: e.target.value,
                      page_type: pageType,
                      page_name: 'size guide screen',
                      product_name: name,
                      product_id: prodCode,
                      store_type: newDesignLuxe ? 'luxe' : 'ajio'
                    });
                    // segment push event                   
                     segmentEventPush({
                        event: 'Size Chart Interactions',
                        event_category: 'size chart interactions',                     
                        //inch_or_cm_flag:  !inches ? 'in' : 'cm',
                        interaction_description:'Custom Radio', 
                        products:[{
                            ...getProductItemPDP(this.props?.productData), 
                        }],
                        screen_name: 'size guide screen',
                        store_type: newDesignLuxe ? 'luxe' : 'ajio',
                        size_selected_in_radio: e.target.value
                      });
                    this.selectSize(e, index);
                  }}
                  name="size"
                  id={sizeDetails.SIZE_NAME}
                  value={sizeDetails.SIZE_NAME}
                  type="radio"
                  className={`${sizeDetails.STOCK_LEVEL ? '' : 'disabled'}`}
                  disabled={!sizeDetails.STOCK_LEVEL}
                  defaultChecked={`${sizeIndex && index === sizeIndex ? 'defaultChecked' : ''}`}
                  tabIndex={-1}
                />
                <span
                  className={`ic-Radio-Buton-Of default-radio ${
                    sizeDetails.STOCK_LEVEL ? '' : 'disabled'
                  }`}
                />
                {sizeDetails.SIZE_NAME}
              </label>
            </td>
          );
        } else {
          sizeRows.push(
            <td key={`r-${index}`} className="td-radio">
              {sizeDetails.SIZE_NAME}
            </td>
          );
        }
      }
      if (brandCompare) {
        if (index === 0 && this.brandList.length > 0 && !this.state.brand_selected) {
          sizeRows.push(
            <td
              key={`rblnk-${index}`}
              className="default-brand-txt brand-col"
              rowSpan={sizeChart.length}
              onClick={this.openBrandList}
            >
              {defaultBlnkText}
            </td>
          );
        }

        if (this.state.brand_selected && targetBrand) {
          sizeRows.push(
            <td className="brand-col" key={`rb-${index}`}>
              {sizeDetails[targetBrand]}
            </td>
          );
        }
        {
          index === 0 &&
            this.brandList.length > 0 &&
            sizeTable.columns.push(
              <th key={`rblnk_val-${index}`} className="brand-col" onClick={this.openBrandList}>
                {`${
                  targetBrand ? `${targetBrand.split('_')[0].toUpperCase()} Size` : 'Brand Compare'
                }`}
                <span className="ic-Chevron-down" />
              </th>
            );
        }
      }
      if ('SIZEGUIDE_MEASUREMENT_UNIT' in sizeDetails) {
        if (sizeDetails.SIZEGUIDE_MEASUREMENT_UNIT == '0') {
          measurementUnit = '';
          //  }else if(sizeDetails.SIZEGUIDE_MEASUREMENT_UNIT == "1" || this.props.inches === false){
        } else if (this.props.inches === false) {
          measurementUnit = 'cm';
        }
      }
      let brandFormat;
      let standardFormat;
      let brandColumn;
      let standardColumn;
      let flag = 0;
      let brandRowRadio = [];
      let standardRowRadio = [];
      let brandIndex = 0;
      let standardIndex = 0;
      if (newFeatureFlag) {
        const self = this;
        // Get size format
        index === 0 &&
          Object.keys(sizeDetails).forEach(function(s_value, s_key) {
            brandFormat =
              s_value.toLowerCase().indexOf('brand size format') >= 0 &&
              sizeDetails[s_value] !== 'UNI'
                ? sizeDetails[s_value]
                : brandFormat;
            standardFormat =
              s_value.toLowerCase().indexOf('universal size format') >= 0 &&
              sizeDetails[s_value] !== 'UNI' &&
              sizeDetails[s_value] !== 'IN'
                ? sizeDetails[s_value]
                : standardFormat;
          });
        // Get Brand and Universal Column Header
        Object.keys(sizeDetails).forEach(function(s_value, s_key) {
          const value = s_value.split('_')[0];

          if (s_value.toLowerCase().indexOf('brand size_attribute') === 0) {
            brandColumn = (
              <th key={`h-${s_key}`}>
                {value}
                {brandFormat && brandFormat !== 'null' ? `(${brandFormat})` : null}
              </th>
            );
          }
          if (s_value.toLowerCase().indexOf('universal size_attribute') === 0) {
            standardColumn = (
              <th key={`h-${s_key}`}>
                Size{standardFormat && standardFormat !== 'null' ? `(${standardFormat})` : null}
              </th>
            );
          }
        });

        // In case if flag is ON but "brand size_attribute" and "universal size_attribute" did not come in response then take size column
        if (
          'Size_HEADER' in sizeDetails &&
          !sizeTable.columns.includes(sizeDetails.Size_HEADER) &&
          newFeatureFlag &&
          !standardColumn
        ) {
          {
            index === 0 &&
              !standardColumn &&
              sizeTable.columns.push(<th key={`h-${index}`}>Size</th>);
          }
          {
            index === 0 &&
              brandColumn &&
              sizeTable.columns.push(
                <th key={`h-${index}`}>
                  Brand Size{brandFormat && brandFormat !== 'null' ? `(${brandFormat})` : null}
                </th>
              );
          }
          if (!app) {
            sizeRows.push(
              <td
                key={`r-${index}`}
                className={`td-radio ${index === sizeIndex ? 'selected-row' : ''} ${
                  sizeDetails.STOCK_LEVEL ? '' : 'disabled'
                }`}
              >
                <label
                  className="custom-radio"
                  // tabIndex={0}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      gtmEventPush({
                        event: 'size_chart_interaction',
                        event_category: 'size chart interactions',
                        event_action: e.target.value,
                        page_type: pageType,
                        page_name: 'size guide screen',
                        product_name: name,
                        product_id: prodCode,
                        store_type: newDesignLuxe ? 'luxe' : 'ajio'
                      });
                      this.selectSize(e, index);
                    }
                  }}
                >
                  <input
                    onClick={e => {
                      gtmEventPush({
                        event: 'size_chart_interaction',
                        event_category: 'size chart interactions',
                        event_action: e.target.value,
                        page_type: pageType,
                        page_name: 'size guide screen',
                        product_name: name,
                        product_id: prodCode,
                        store_type: newDesignLuxe ? 'luxe' : 'ajio'
                      });
                      // Segment push event
                       segmentEventPush({
                        event: 'Size Chart Interactions',
                        event_category: 'size chart interactions',                     
                        //inch_or_cm_flag:  !inches ? 'in' : 'cm',
                        interaction_description:'Custom Radio', 
                        products:[{
                          ...getProductItemPDP(this.props?.productData), 
                        }],     
                        screen_name: 'size guide screen',
                        store_type: newDesignLuxe ? 'luxe' : 'ajio',
                        size_selected_in_radio: e.target.value
                      });
                      this.selectSize(e, index);
                    }}
                    name="size"
                    id={sizeDetails.SIZE_NAME}
                    value={sizeDetails.SIZE_NAME}
                    type="radio"
                    className={`${sizeDetails.STOCK_LEVEL ? '' : 'disabled'}`}
                    disabled={!sizeDetails.STOCK_LEVEL}
                    defaultChecked={`${sizeIndex && index === sizeIndex ? 'defaultChecked' : ''}`}
                    tabIndex={-1}
                  />
                  <span
                    className={`ic-Radio-Buton-Of default-radio ${
                      sizeDetails.STOCK_LEVEL ? '' : 'disabled'
                    }`}
                  />
                  {sizeDetails.SIZE_NAME}
                </label>
              </td>
            );
          } else {
            sizeRows.push(
              <td key={`r-${index}`} className="td-radio">
                {sizeDetails.SIZE_NAME}
              </td>
            );
          }
        }

        Object.keys(sizeDetails).forEach(function(s_value, s_key) {
          if (s_value.toLowerCase().indexOf('brand size_attribute') === 0) {
            if (sizeType.toUpperCase() === 'BRAND') {
              brandRowRadio.push(
                <td
                  key={`r-${index}`}
                  className={`td-radio ${index === sizeIndex ? 'selected-row' : ''} ${
                    sizeDetails.STOCK_LEVEL ? '' : 'disabled'
                  }`}
                >
                  <label
                    className="custom-radio"
                    // tabIndex={0}
                    // onKeyDown={(event) => {
                    //   if (event.key === 'Enter' || event.key === ' ') {
                    //     event.preventDefault();
                    //     gtmEventPush({
                    //       event: 'size_chart_interaction',
                    //       event_category: 'size chart interactions',
                    //       event_action: e.target.value,
                    //       page_type: pageType,
                    //       page_name: 'size guide screen',
                    //       product_name: name,
                    //       product_id: prodCode,
                    //       store_type: newDesignLuxe ? 'luxe' : 'ajio'
                    //     });
                    //     self.selectSize(e, index);
                    //   }
                    // }}
                  >
                    <input
                      onClick={e => {
                        gtmEventPush({
                          event: 'size_chart_interaction',
                          event_category: 'size chart interactions',
                          event_action: e.target.value,
                          page_type: pageType,
                          page_name: 'size guide screen',
                          product_name: name,
                          product_id: prodCode,
                          store_type: newDesignLuxe ? 'luxe' : 'ajio'
                        });
                        // segment push event
                         segmentEventPush({
                            event: 'Size Chart Interactions',
                            event_category: 'size chart interactions',                     
                            //inch_or_cm_flag:  !inches ? 'in' : 'cm',
                            interaction_description:'Custom Radio', 
                            products:[{
                               ...getProductItemPDP(productData), 
                            }],
                            screen_name: 'size guide screen',
                            store_type: newDesignLuxe ? 'luxe' : 'ajio',
                            size_selected_in_radio: e.target.value
                        });
                        self.selectSize(e, index);
                      }}
                      name="size"
                      id={sizeDetails.SIZE_NAME}
                      value={sizeDetails.SIZE_NAME}
                      type="radio"
                      className={`${sizeDetails.STOCK_LEVEL ? '' : 'disabled'}`}
                      disabled={!sizeDetails.STOCK_LEVEL}
                      defaultChecked={`${sizeIndex && index === sizeIndex ? 'defaultChecked' : ''}`}
                      tabIndex={-1}
                    />
                    <span
                      className={`ic-Radio-Buton-Of default-radio ${
                        sizeDetails.STOCK_LEVEL ? '' : 'disabled'
                      }`}
                    />
                    {sizeDetails[s_value]}
                  </label>
                </td>
              );
            } else {
              brandRowRadio.push(
                <td className={`${index === sizeIndex ? 'selected-row' : ''}`} key={`rs-${s_key}`}>
                  {sizeDetails[s_value]}
                </td>
              );
            }
          }
          if (s_value.toLowerCase().indexOf('universal size_attribute') === 0) {
            if (sizeType.toUpperCase() === 'STANDARD') {
              standardRowRadio.push(
                <td
                  key={`r-${index}`}
                  className={`td-radio ${index === sizeIndex ? 'selected-row' : ''} ${
                    sizeDetails.STOCK_LEVEL ? '' : 'disabled'
                  }`}
                >
                  <label
                    className="custom-radio"
                    // tabIndex={0}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        gtmEventPush({
                          event: 'size_chart_interaction',
                          event_category: 'size chart interactions',
                          event_action: e.target.value,
                          page_type: pageType,
                          page_name: 'size guide screen',
                          product_name: name,
                          product_id: prodCode,
                          store_type: newDesignLuxe ? 'luxe' : 'ajio'
                        });
                        self.selectSize(e, index);
                      }
                    }}
                  >
                    <input
                      onClick={e => {
                        gtmEventPush({
                          event: 'size_chart_interaction',
                          event_category: 'size chart interactions',
                          event_action: e.target.value,
                          page_type: pageType,
                          page_name: 'size guide screen',
                          product_name: name,
                          product_id: prodCode,
                          store_type: newDesignLuxe ? 'luxe' : 'ajio'
                        });

                        // Segment Push Event
                         segmentEventPush({
                          event: 'Size Chart Interactions',
                          event_category: 'size chart interactions',                     
                          //inch_or_cm_flag:  !inches ? 'in' : 'cm',
                          interaction_description:'Custom Radio',
                          products:[{
                            ...getProductItemPDP(this.props?.productData), 
                          }],
                          screen_name: 'size guide screen',
                          store_type: newDesignLuxe ? 'luxe' : 'ajio',
                          size_selected_in_radio: e.target.value
                       });
                        self.selectSize(e, index);
                      }}
                      name="size"
                      id={sizeDetails.SIZE_NAME}
                      value={sizeDetails.SIZE_NAME}
                      type="radio"
                      className={`${sizeDetails.STOCK_LEVEL ? '' : 'disabled'}`}
                      disabled={!sizeDetails.STOCK_LEVEL}
                      defaultChecked={`${sizeIndex && index === sizeIndex ? 'defaultChecked' : ''}`}
                      tabIndex={-1}
                    />
                    <span
                      className={`ic-Radio-Buton-Of default-radio ${
                        sizeDetails.STOCK_LEVEL ? '' : 'disabled'
                      }`}
                    />
                    {sizeDetails[s_value]}
                  </label>
                </td>
              );
            } else {
              standardRowRadio.push(
                <td className={`${index === sizeIndex ? 'selected-row' : ''}`} key={`rs-${s_key}`}>
                  {sizeDetails[s_value]}
                </td>
              );
            }
          }
        });
      }

      
      Object.keys(sizeDetails).forEach(function(s_value, s_key) {
        if (
          s_value.toUpperCase().indexOf('_ATTRIBUTE') >= 0 &&
          s_value.toLowerCase().indexOf('universal size format') === -1 &&
          s_value.toLowerCase().indexOf('brand size format') === -1
        ) {
          const value = s_value.split('_')[0];

          if (defaultUnit === false) {
            if (inches === true) {
              if (s_value.toUpperCase().indexOf('_INCH_') >= 0) {
                // sizeRows.push(<td className={`${index===sizeIndex?'selected-row':''}`} key={`rs-${s_key}`}>{sizeDetails[s_value]}</td>);
                const value_unit = s_value.split('_')[2];
                if (newFeatureFlag && sizeType) {
                  if (sizeType.toUpperCase() === 'BRAND') {
                    // sizeRows.push(brandRowRadio[brandIndex++]);
                    if (s_value.toLowerCase().indexOf('brand size_attribute') > -1) {
                      sizeRows.splice(1, 0, brandRowRadio[brandIndex++]);
                    }
                    if (s_value.toLowerCase().indexOf('universal size_attribute') > -1) {
                      sizeRows.splice(
                        0,
                        0,
                        <td
                          className={`${index === sizeIndex ? 'selected-row' : ''}`}
                          key={`rs-${s_key}`}
                        >
                          {sizeDetails[s_value]}
                        </td>
                      );
                    }
                  }
                  if (sizeType.toUpperCase() === 'STANDARD') {
                    // sizeRows.push(standardRowRadio[standardIndex++]);

                    if (s_value.toLowerCase().indexOf('universal size_attribute') > -1) {
                      sizeRows.splice(0, 0, standardRowRadio[standardIndex++]);
                    }
                    if (s_value.toLowerCase().indexOf('brand size_attribute') > -1) {
                      sizeRows.splice(
                        1,
                        0,
                        <td
                          className={`${index === sizeIndex ? 'selected-row' : ''}`}
                          key={`rs-${s_key}`}
                        >
                          {sizeDetails[s_value]}
                        </td>
                      );
                    }
                  }
                  if (
                    sizeType.toUpperCase() === 'BRAND' &&
                    s_value.toLowerCase().indexOf('brand size_attribute') === -1 &&
                    s_value.toLowerCase().indexOf('universal size_attribute') === -1
                  ) {
                    sizeRows.push(
                      <td
                        className={`${index === sizeIndex ? 'selected-row' : ''}`}
                        key={`rs-${s_key}`}
                      >
                        {sizeDetails[s_value]}
                      </td>
                    );
                  }
                  if (
                    sizeType.toUpperCase() === 'STANDARD' &&
                    s_value.toLowerCase().indexOf('universal size_attribute') === -1 &&
                    s_value.toLowerCase().indexOf('brand size_attribute') === -1
                  ) {
                    sizeRows.push(
                      <td
                        className={`${index === sizeIndex ? 'selected-row' : ''}`}
                        key={`rs-${s_key}`}
                      >
                        {sizeDetails[s_value]}
                      </td>
                    );
                  }
                } else {
                  if (!newFeatureFlag) {
                    if (s_value.toLowerCase().indexOf('universal size_attribute') === -1) {
                      sizeRows.push(
                        <td
                          className={`${index === sizeIndex ? 'selected-row' : ''}`}
                          key={`rs-${s_key}`}
                        >
                          {sizeDetails[s_value]}
                        </td>
                      );
                    }
                  }
                }
                // {index === 0 && sizeTable.columns.push(<th key={`h-${s_key}`}>{value_unit}</th>)}

                if (index === 0) {
                  if (newFeatureFlag && sizeType) {
                    if (
                      sizeType.toUpperCase() === 'BRAND' &&
                      flag === 0 &&
                      s_value.toLowerCase().indexOf('brand size_attribute') > -1
                    ) {
                      sizeTable.columns.splice(1, 0, brandColumn);
                      sizeTable.columns.splice(0, 0, standardColumn);
                      flag = 1;
                    } else if (
                      sizeType.toUpperCase() === 'STANDARD' &&
                      flag === 0 &&
                      s_value.toLowerCase().indexOf('universal size_attribute') > -1
                    ) {
                      sizeTable.columns.splice(0, 0, standardColumn);
                      sizeTable.columns.splice(1, 0, brandColumn);
                      flag = 1;
                    } else {
                      if (
                        s_value.toLowerCase().indexOf('brand size_attribute') === -1 &&
                        s_value.toLowerCase().indexOf('universal size_attribute') === -1
                      ) {
                        sizeTable.columns.push(<th key={`h-${s_key}`}>{value_unit}</th>);
                      }
                    }
                  } else {
                    if (!newFeatureFlag) {
                      if (s_value.toLowerCase().indexOf('universal size_attribute') === -1) {
                        sizeTable.columns.push(<th key={`h-${s_key}`}>{value_unit}</th>);
                      }
                    } else {
                      sizeTable.columns.push(<th key={`h-${s_key}`}>{value_unit}</th>);
                    }
                  }
                }
              }
            } else {
              if (s_value.toUpperCase().indexOf('_CM_') >= 0) {
                // sizeRows.push(<td className={`${index===sizeIndex?'selected-row':''}`} key={`rs-${s_key}`}>{sizeDetails[s_value]}</td>);
                const value_unit = s_value.split('_')[2];

                if (newFeatureFlag && sizeType) {
                  if (sizeType.toUpperCase() === 'BRAND') {
                    // sizeRows.push(brandRowRadio[brandIndex++]);
                    if (s_value.toLowerCase().indexOf('brand size_attribute') > -1) {
                      sizeRows.splice(1, 0, brandRowRadio[standardIndex++]);
                    }
                    if (s_value.toLowerCase().indexOf('universal size_attribute') > -1) {
                      sizeRows.splice(
                        0,
                        0,
                        <td
                          className={`${index === sizeIndex ? 'selected-row' : ''}`}
                          key={`rs-${s_key}`}
                        >
                          {sizeDetails[s_value]}
                        </td>
                      );
                    }
                  }
                  if (sizeType.toUpperCase() === 'STANDARD') {
                    if (s_value.toLowerCase().indexOf('universal size_attribute') > -1) {
                      sizeRows.splice(0, 0, standardRowRadio[standardIndex++]);
                    }
                    if (s_value.toLowerCase().indexOf('brand size_attribute') > -1) {
                      sizeRows.splice(
                        1,
                        0,
                        <td
                          className={`${index === sizeIndex ? 'selected-row' : ''}`}
                          key={`rs-${s_key}`}
                        >
                          {sizeDetails[s_value]}
                        </td>
                      );
                    }
                  }
                  if (
                    sizeType.toUpperCase() === 'BRAND' &&
                    s_value.toLowerCase().indexOf('brand size_attribute') === -1 &&
                    s_value.toLowerCase().indexOf('universal size_attribute') === -1
                  ) {
                    sizeRows.push(
                      <td
                        className={`${index === sizeIndex ? 'selected-row' : ''}`}
                        key={`rs-${s_key}`}
                      >
                        {sizeDetails[s_value]}
                      </td>
                    );
                  }
                  if (
                    sizeType.toUpperCase() === 'STANDARD' &&
                    s_value.toLowerCase().indexOf('universal size_attribute') === -1 &&
                    s_value.toLowerCase().indexOf('brand size_attribute') === -1
                  ) {
                    sizeRows.push(
                      <td
                        className={`${index === sizeIndex ? 'selected-row' : ''}`}
                        key={`rs-${s_key}`}
                      >
                        {sizeDetails[s_value]}
                      </td>
                    );
                  }
                } else {
                  if (!newFeatureFlag) {
                    if (s_value.toLowerCase().indexOf('universal size_attribute') === -1) {
                      sizeRows.push(
                        <td
                          className={`${index === sizeIndex ? 'selected-row' : ''}`}
                          key={`rs-${s_key}`}
                        >
                          {sizeDetails[s_value]}
                        </td>
                      );
                    }
                  }
                }
                // {index === 0 && sizeTable.columns.push(<th key={`h-${s_key}`}>4444444{value_unit}</th>)}
                if (index === 0) {
                  if (newFeatureFlag && sizeType) {
                    if (
                      sizeType.toUpperCase() === 'BRAND' &&
                      flag === 0 &&
                      s_value.toLowerCase().indexOf('brand size_attribute') > -1
                    ) {
                      sizeTable.columns.splice(1, 0, brandColumn);
                      sizeTable.columns.splice(0, 0, standardColumn);
                      flag = 1;
                    } else if (
                      sizeType.toUpperCase() === 'STANDARD' &&
                      flag === 0 &&
                      s_value.toLowerCase().indexOf('universal size_attribute') > -1
                    ) {
                      sizeTable.columns.splice(0, 0, standardColumn);
                      if(brandCompare) {
                        sizeTable.columns.splice(2, 0, brandColumn);
                      } else {
                        sizeTable.columns.splice(1, 0, brandColumn);
                      }
                      flag = 1;
                    } else {
                      if (
                        s_value.toLowerCase().indexOf('brand size_attribute') === -1 &&
                        s_value.toLowerCase().indexOf('universal size_attribute') === -1
                      ) {
                        sizeTable.columns.push(<th key={`h-${s_key}`}>{value_unit}</th>);
                      }
                    }
                  } else {
                    if (!newFeatureFlag) {
                      if (s_value.toLowerCase().indexOf('universal size_attribute') === -1) {
                        sizeTable.columns.push(<th key={`h-${s_key}`}>{value_unit}</th>);
                      }
                    } else {
                      sizeTable.columns.push(<th key={`h-${s_key}`}>{value_unit}</th>);
                    }
                  }
                }
              }
            }
          } else if (
            s_value.toUpperCase().indexOf('_CM_') === -1 &&
            s_value.toUpperCase().indexOf('_INCH_') === -1 &&
            defaultUnit === true
          ) {
            // sizeRows.push(<td className={`${index===sizeIndex?'selected-row':''}`} key={`rs-${s_key}`}>{sizeDetails[s_value]}-=-=-=-</td>);
            // {index === 0 && brandFormat ? : sizeTable.columns.push(<th key={`h-${s_key}`}>{value}*****</th>)}

            // show row with size
            if (newFeatureFlag && sizeType) {
              if (sizeType.toUpperCase() === 'BRAND') {
                // sizeRows.push(brandRowRadio[brandIndex++]);
                if (s_value.toLowerCase().indexOf('brand size_attribute') > -1) {
                  sizeRows.splice(0, 0, brandRowRadio[standardIndex++]);
                }
                if (s_value.toLowerCase().indexOf('universal size_attribute') > -1) {
                  sizeRows.splice(
                    1,
                    0,
                    <td
                      className={`${index === sizeIndex ? 'selected-row' : ''}`}
                      key={`rs-${s_key}`}
                    >
                      {sizeDetails[s_value]}
                    </td>
                  );
                }
              }
              if (sizeType.toUpperCase() === 'STANDARD') {
                if (s_value.toLowerCase().indexOf('universal size_attribute') > -1) {
                  sizeRows.splice(0, 0, standardRowRadio[standardIndex++]);
                }
                if (s_value.toLowerCase().indexOf('brand size_attribute') > -1) {
                  sizeRows.splice(
                    1,
                    0,
                    <td
                      className={`${index === sizeIndex ? 'selected-row' : ''}`}
                      key={`rs-${s_key}`}
                    >
                      {sizeDetails[s_value]}
                    </td>
                  );
                }
              }
              if (
                sizeType.toUpperCase() === 'BRAND' &&
                s_value.toLowerCase().indexOf('brand size_attribute') === -1 &&
                s_value.toLowerCase().indexOf('universal size_attribute') === -1
              ) {
                sizeRows.push(
                  <td
                    className={`${index === sizeIndex ? 'selected-row' : ''}`}
                    key={`rs-${s_key}`}
                  >
                    {sizeDetails[s_value]}
                  </td>
                );
              }
              if (
                sizeType.toUpperCase() === 'STANDARD' &&
                s_value.toLowerCase().indexOf('universal size_attribute') === -1 &&
                s_value.toLowerCase().indexOf('brand size_attribute') === -1
              ) {
                sizeRows.push(
                  <td
                    className={`${index === sizeIndex ? 'selected-row' : ''}`}
                    key={`rs-${s_key}`}
                  >
                    {sizeDetails[s_value]}
                  </td>
                );
              }
            } else {
              if (!newFeatureFlag) {
                if (s_value.toLowerCase().indexOf('universal size_attribute') === -1) {
                  sizeRows.push(
                    <td
                      className={`${index === sizeIndex ? 'selected-row' : ''}`}
                      key={`rs-${s_key}`}
                    >
                      {sizeDetails[s_value]}
                    </td>
                  );
                }
              }
            }
            // show table header
            if (index === 0) {
              if (newFeatureFlag && sizeType) {
                if (
                  sizeType.toUpperCase() === 'BRAND' &&
                  flag === 0 &&
                  s_value.toLowerCase().indexOf('brand size_attribute') > -1
                ) {
                  sizeTable.columns.splice(1, 0, brandColumn);
                  sizeTable.columns.splice(0, 0, standardColumn);
                  flag = 1;
                } else if (
                  sizeType.toUpperCase() === 'STANDARD' &&
                  flag === 0 &&
                  s_value.toLowerCase().indexOf('universal size_attribute') > -1
                ) {
                  sizeTable.columns.splice(0, 0, standardColumn);
                  if(brandCompare) {
                    sizeTable.columns.splice(2, 0, brandColumn);
                  } else {
                    sizeTable.columns.splice(1, 0, brandColumn);
                  }
                  flag = 1;
                } else {
                  if (
                    s_value.toLowerCase().indexOf('brand size_attribute') === -1 &&
                    s_value.toLowerCase().indexOf('universal size_attribute') === -1
                  ) {
                    sizeTable.columns.push(<th key={`h-${s_key}`}>{value}</th>);
                  }
                }
              } else {
                if (!newFeatureFlag) {
                  if (s_value.toLowerCase().indexOf('universal size_attribute') === -1) {
                    sizeTable.columns.push(<th key={`h-${s_key}`}>{value}</th>);
                  }
                } else {
                  sizeTable.columns.push(<th key={`h-${s_key}`}>{value}</th>);
                }
              }
            }
          }
        }
        if (
          s_value.toUpperCase().indexOf('_COUNTRY') >= 0 &&
          s_value.toUpperCase() != 'AJIO_COUNTRY' &&
          s_value.toUpperCase() != 'DEFAULT_OTHER_COUNTRY_COMPARISON'
        ) {
          icFlag = true;
          const value = s_value.split('_')[0];
          icRows.push(<td key={`rc-${s_key}`}>{sizeDetails[s_value]}</td>);
          {
            index === 0 && countryTable.columns.push(<th key={`h-${s_key}`}>{value}</th>);
          }
        }
      });

      sizeTable.rows.push(<tr key={`row-${index}`}>{sizeRows}</tr>);
      countryTable.rows.push(<tr key={`row-${index}`}>{icRows}</tr>);
    });

    {
      modelData.map((list, i) =>
        list.featureValues.map((sublist, j) => {
          if (list.name === 'Size worn by Model' && sublist.value) {
            SizeWornByModel = sublist.value;
          }
          if (list.name === 'Model Chest Size' && sublist.value) {
            ModelChestSize = sublist.value;
          }
          if (list.name === 'Model Height' && sublist.value) {
            ModelHeight = sublist.value;
          }
          if (list.name === 'Model Waist Size' && sublist.value) {
            ModelWaistSize = sublist.value;
          }
        })
      );
    }
    const {
      singleSizeRecommend = false,
      howToMeasureVisibleInSizeGuideFlag,
      selectedSizeName
    } = this.props;
    const singleRecommendVariant = getFeatureVariant('singleRecommend') || '0';
    const recommendedData =
      singleRecommendVariant === '1'
        ? this.singleRecommendData(sizeRecommendPopUpData?.purchasedOrdersData)
        : sizeRecommendPopUpData?.purchasedOrdersData;
    const { sizechart = [] } = sizeRecommendPopUpData || '';
    let sizeRecomModalDOM =
      sizeRecommendPopUpData &&
      sizeRecommendPopUpData.hasOwnProperty('purchasedOrdersData') &&
      sizeRecommendPopUpData.purchasedOrdersData &&
      recommendedData?.length > 0
        ? recommendedData?.map((item, index) => {
            let datetimestamp = item.timestamp;
            // let tips = sizeRecommendPopUpData.sizechart[0].tips;
            let tips = item.tips;
            // let brandName = sizeRecommendPopUpData.sizechart[0].brandName;
            // let brickName = sizeRecommendPopUpData.sizechart[0].brickName;

            let sizeMeasurement = ' ';
            let sizeMeasurementRecom = ' ';
            for (var key in item.sizeChartAttributes) {
              sizeMeasurement += `${key.toString().substr(0, key.toString().indexOf('_'))}: ${
                item.sizeChartAttributes[key]
              } `;
            }
            if (sizeMeasurement !== ' ') {
              sizeMeasurement = sizeMeasurement.substr(0, sizeMeasurement.length - 1);
              sizeMeasurement += '*';
            }
            for (var key in item.recommendedSizeChartAttributes) {
              sizeMeasurementRecom += `${key.toString().substr(0, key.toString().indexOf('_'))}: ${
                item.recommendedSizeChartAttributes[key]
              }  `;
            }
            if (sizeMeasurementRecom !== ' ') {
              sizeMeasurementRecom = sizeMeasurementRecom.substr(
                0,
                sizeMeasurementRecom.length - 1
              );
              sizeMeasurementRecom += '*';
            }

            return (
              <div className="carousel-mob-items" key={index} data-currentslide={index}>
                <div className="carousel-image-desc">
                  <div className="carousel-desc">
                    <p className="size-desc">
                      Size
                      <span className="recommend"> {item.recommendedSize} </span>
                      corresponds to {item.sizeName} of this previously bought
                      {item.brandName && item.brickName ? (
                        <span className="size-category">
                          {' '}
                          {item.brandName}: {item.brickName}
                        </span>
                      ) : item.brandName ? (
                        <span className="size-category"> {item.brandName}</span>
                      ) : item.brickName ? (
                        <span className="size-category"> {item.brickName}</span>
                      ) : (
                        <span className="size-category"> item</span>
                      )}
                    </p>
                    <p className="size-date">
                      Bought on: {datetimestamp ? moment(datetimestamp).format('MMM YYYY') : ''}
                    </p>
                    {/* <a className="size-recom-btn">SELECT <span className="btn-size">{item.recommendedSize}</span></a> */}
                  </div>
                  <div className="img-cont">
                    {/* <img src="https://assets.ajio.com/medias/sys_master/root/h15/h13/12916169703454/-78Wx98H-440939494-blue-MODEL.jpg" alt="size" /> */}
                    <img src={replaceWithJioCDN(item.lastOrderImage1Url)} alt="lastOrderImg" />
                  </div>
                </div>
                <div className="carousel-measurement">
                  <h4 className="size-recomd-measure-header">
                    {sizechart ? sizechart[0].measurementType : ''}
                  </h4>
                  {/* <p className="size-m size-prev-bought"><span>Previously bought: L</span> | Bust: 38  Waist: 31  Hips: 42*</p> */}
                  <div className="size-m size-prev-bought">
                    <p className="desc-1">Previously bought: {item.sizeName}&ensp;</p>
                    {/* <p className="desc-2"> | Bust: 38  Waist: 31  Hips: 42*</p> */}
                    <p className="desc-2">{sizeMeasurement || '&ensp;'}</p>
                  </div>
                  {/* <p className="size-m size-mob-recom"><span>Recommended: XXXL</span> | Bust: 36  Waist: 31  Hips: 42*</p> */}
                  <div className="size-m size-mob-recom">
                    <p className="desc-1">Recommended: {item.recommendedSize}&ensp;</p>
                    {/* <p className="desc-2">| Bust: 36  Waist: 31  Hips: 42*</p> */}
                    <p className="desc-2">{sizeMeasurementRecom}</p>
                  </div>
                  {/* <p className="size-tip">A larger size is recommended because of different fit.</p> */}
                  {/* <p className="size-tip">{tips}</p> */}
                </div>
              </div>
            );
          })
        : null;

    function tabRelatedGA(currentActiveKey) {
      const { code: prodCode = '', name = '' } = productData || {};
      const tabSelected = currentTabs[currentActiveKey - 1] || '';
      gtmEventPush({
        event: 'size_chart_interaction',
        event_category: 'size chart interactions',
        event_action: tabSelected,
        event_label: `${tabSelected} - tab`,
        page_type: pageType,
        page_name: 'size guide screen',
        product_name: name,
        product_id: prodCode,
        product_brand: curentBrand || '',
        product_size: selectedSizeName,
        store_type: newDesignLuxe ? 'luxe' : 'ajio'
      });
      // Segment Push event
      segmentEventPush({
          event: 'Size Chart Interactions',
          event_category: 'size chart interactions',                     
          //inch_or_cm_flag:  !inches ? 'in' : 'cm',
          interaction_description:`${tabSelected} - tab`, 
          products:[{
            ...getProductItemPDP(productData),
          }],
          screen_name: 'size guide screen',
          screen_type: pageType,
          store_type: newDesignLuxe ? 'luxe' : 'ajio',
          size_selected_in_radio: selectedSizeName
      });

      if (tabSelected == howToMeasureTxt && !hasHowToMeasureObserverCallForTab) {
        hasHowToMeasureObserverCallForTab = true;
        howToMeasureImageSeenGA();
        howToMeasureImageTypeGA();
      }
    }
    function howToMeasureImageTypeGA() {
      gtmEventPush({
        event: 'size_chart_interactions',
        event_category: 'size chart interactions',
        event_action: 'how to measure images seen',
        event_label: howToMeasureNewImagesFlag ? 'new' : 'old',
        page_type: pageType,
        page_name: 'size guide screen',
        product_id: prodCode,
        product_name: name,
        product_brand: curentBrand || '',
        store_type: newDesignLuxe ? 'luxe' : 'ajio'
      });
    }
    function howToMeasureImageSeenGA() {
      gtmEventPush({
        event: 'size_chart_interactions',
        event_category: 'size chart interactions',
        event_action: 'how to measure images seen',
        event_label: 'yes',
        page_type: pageType,
        page_name: 'size guide screen',
        product_id: prodCode,
        product_name: name,
        product_brand: curentBrand || '',
        store_type: newDesignLuxe ? 'luxe' : 'ajio'
      });
    }
    let allowRecommendationSize = true;
    if (sizeRecommendationPrimeAILinkFlag && !newDesignLuxe) {
      allowRecommendationSize = false;
    }
    return (
      <div
        className="size-guide-container-adv"
        onClick={e => {
          this.handleClick(e);
        }}
      >
        <p className="brand-name">Brand : {curentBrand || ''}</p>
        {/* {brandLogo && !this.state.errored && <div className="brand-logo"><img src={`${brandLogo}`} onError={this.handleError} /></div>} */}
        <div className="size-details-tab">
          <Tabs
            defaultActiveKey={1}
            id="size-guide-tab"
            onSelect={currentActiveKey => tabRelatedGA(currentActiveKey)}
          >
            <Tab eventKey={1} title="Size Guide">
              {singleSizeRecommend &&
                allowRecommendationSize &&
                sizeRecomModalDOM &&
                sizeRecomModalDOM.length > 0 && (
                  <div>
                    <h3 className="size-recomd-header">Recommended Size</h3>
                    <div className="carousel-mob-container">{sizeRecomModalDOM}</div>
                    {recommendedData.length > 1 && (
                      <div className="size-recom-slider">
                        <div
                          className="size-slide size-recom-non-active"
                          onClick={e => this.handlePrev(e)}
                        >
                          <div /> Previous
                        </div>
                        <div
                          className="size-slide size-recom-active"
                          onClick={e => this.handleNext(e)}
                        >
                          Next <div />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              <div className="size-tab">
                <div className="sizeguide-title">
                  {measurementType}
                  {measurementUnit && (
                    <span>
                      (
                      {fitType ? (
                        <span>
                          {fitType} | {measurementUnit}
                        </span>
                      ) : (
                        <span
                          aria-label={measurementUnit === 'cm' ? 'centimeter' : measurementUnit}
                        >
                          {measurementUnit}
                        </span>
                      )}
                      )
                    </span>
                  )}
                  {!this.props.hideToggle && (
                    <ToggleButton
                      handleToggleInchCM={this.props.handleToggleInchCM}
                      inches={this.props.inches}
                      measurementType={measurementType}
                    />
                  )}
                </div>
                <div className="size-table-container" data-test='true'>
                  <Table tableConfig={sizeTable} />
                  {this.brandList && this.brandList.length > 0 ? (
                    <BrandList
                      showMenu={this.state.showMenu}
                      brands={this.brandList}
                      setBrand={this.setBrand}
                      productData={this.props.productData}
                      newDesignLuxe={newDesignLuxe}
                    />
                  ) : null}
                </div>
                <br />
                {/* { recommendTips && <div className="brick-desc">RECOMMENDED : {recommendTips}</div> } 
                    {this.state.brand_selected?<SelfcareGA Feedbck="size-guide" productData={this.props.productData} newDesignLuxe={newDesignLuxe} />:null} */}

                {!howToMeasureVisibleInSizeGuid && (
                  <div style={{ paddingBottom: '15px', width: '358px' }}>
                    <SelfcareGA
                      type="guide"
                      szGuideTxt="Was this information useful?"
                      productCode={prodCode}
                      productName={name}
                      luxe={newDesignLuxe}
                    />
                  </div>
                )}
                {SizeWornByModel && (
                  <div className="model-details">
                    {SizeWornByModel && <div className="model-desc">Model Measurements </div>}
                    <div className="model-img-desc">
                      <img src={`${replaceWithJioCDN(imageUrl)}`} alt="Product image" />
                      <div className="measurement-details">
                        {SizeWornByModel && (
                          <span className="measure-attr">
                            Size<span className="">:</span>
                            {SizeWornByModel}
                          </span>
                        )}
                        {ModelHeight && (
                          <span className="measure-attr">
                            Height<span className="">:</span>
                            {ModelHeight}
                          </span>
                        )}
                        {ModelChestSize ? (
                          <span className="measure-attr">
                            Chest<span className="">:</span>
                            {ModelChestSize}
                          </span>
                        ) : (
                          ''
                        )}
                        {ModelWaistSize ? (
                          <span className="measure-attr">
                            Waist<span className="">:</span>
                            {ModelWaistSize}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div>{sizeTips && <div className="model-tip-msg">Tip : {sizeTips}</div>}</div>
              {howToMeasureVisibleInSizeGuid && measureImgUrl && (
                <>
                  <div className="border-section" />
                  <div className="how-to-measure-title">How to Measure </div>
                  <InView
                    as="div"
                    threshold={0.3}
                    triggerOnce
                    onChange={(inView, entry) => {
                      if (inView) {
                        this.howToMeasureImpression();
                        howToMeasureImageSeenGA();
                        howToMeasureImageTypeGA();
                      }
                    }}
                  >
                    <div className="measure-img">
                      <img src={`${replaceWithJioCDN(measureImgUrl)}`} alt="Measurement image" />
                    </div>
                  </InView>
                  <div style={{ paddingBottom: '15px', width: '358px' }}>
                    <SelfcareGA
                      type="measure"
                      szGuideTxt="Was this information useful?"
                      productCode={prodCode}
                      productName={name}
                      luxe={newDesignLuxe}
                    />
                  </div>
                </>
              )}
            </Tab>
            {icFlag && (
              <Tab eventKey={2} title="International Conversions">
                {this.props.newDesignLuxe ? (
                  <div className="sizeguide-title">
                    {measurementType}
                    {measurementUnit && (
                      <span>
                        (
                        {fitType ? (
                          <span>
                            {fitType} | {measurementUnit}
                          </span>
                        ) : (
                          <span>{measurementUnit}</span>
                        )}
                        )
                      </span>
                    )}
                    {!this.props.hideToggle && (
                      <ToggleButtonIntConv
                        handleToggleInchCM={this.props.handleToggleInchCMIntConv}
                        inches={this.props.inches}
                      />
                    )}
                  </div>
                ) : null}
                <div className="table-container">
                  <Table tableConfig={countryTable} />
                </div>
                <div style={{ paddingBottom: '15px', width: '358px' }}>
                  <SelfcareGA
                    type="international"
                    szGuideTxt="Was this information useful?"
                    productCode={prodCode}
                    productName={name}
                    luxe={newDesignLuxe}
                  />
                </div>
              </Tab>
            )}
            {!howToMeasureVisibleInSizeGuid && measureImgUrl && (
              <Tab eventKey={3} title="How to Measure">
                <InView
                  as="div"
                  threshold={0.3}
                  triggerOnce
                  onChange={(inView, entry) => {
                    if (!this.state.howToMeasureObserved) {
                      this.setState({ howToMeasureObserved: true });
                      this.howToMeasureImpression();
                    }
                  }}
                >
                  <div className="measure-img">
                    <img src={`${replaceWithJioCDN(measureImgUrl)}`} alt="Measurement image" />
                  </div>
                  <div style={{ paddingBottom: '15px', width: '358px' }}>
                    <SelfcareGA
                      type="measure"
                      szGuideTxt="Was this information useful?"
                      productCode={prodCode}
                      productName={name}
                      luxe={newDesignLuxe}
                    />
                  </div>
                </InView>
              </Tab>
            )}
          </Tabs>
        </div>
      </div>
    );
  }

  handlePropagation = e => {
    e.stopPropagation();
  };

  openWidget = () => {
    if (window.OpenWidget) {
      window.OpenWidget();
      const primeAIGAtype = localStorage.getItem('primeAIGAtype') || 'INIT';
      gtmPrimeAICTA(primeAIGAtype);
    }
  };

  checkPrimeAIWidgetView = () => {
    const element = this.primeAIButton.current;
    console.log('🚀 ~ file: SizeGuide.js ~ line 971 ~ SizeGuide ~ element', element);
    const isElementView = (element && this.isInViewport(element)) || null;
    console.log('🚀 ~ file: SizeGuide.js ~ line 972 ~ SizeGuide ~ isElementView', isElementView);
    if (isElementView) {
      console.log('HIT PRIME UI GA............................');
      gtmPrimeAICTA('WIDGET_VIEW');
    }
  };

  isInViewport = element => {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  setRecommendedSizeLink = (isRecommendedSize, sizeData, isLuxe, showLink) => {
    if (isLuxe) return false;
    return (
      <Feature featureName="prime_ai_size_recomnendation_pdp">
        <Variant id="0" />
        <Variant id="1">
          {isRecommendedSize ? (
            <div className="recommended-size-text-details">
              <p>
                We recommend size <span>{`${sizeData}`}</span> based on the sizing details you
                shared
              </p>
              <a onClick={() => this.openWidget()} id="primeai_button">
                Edit Details
              </a>
            </div>
          ) : (
            <div className="recommended-size-text" ref={this.primeAIButton}>
              <InView
                as="div"
                threshold={0.5}
                triggerOnce
                onChange={() => {
                  gtmEventPush({
                    page_type: 'pdp screen',
                    event: 'size_chart_interaction',
                    category: 'product details interactions',
                    action: 'prime AI recommonded widget view'
                  });
                }}
              >
                <a onClick={() => this.openWidget()} id="primeai_button">
                  {showLink ? 'Find your recommended size' : ''}
                </a>
              </InView>
            </div>
          )}
        </Variant>
      </Feature>
    );
  };

  render() {
    let {
      app = false,
      sizeRecommendData,
      sizeRecommendationPrimeAILinkFlag = false,
      brandCompare = 'OFF'
    } = this.props;
    let sizeChart = this.props.sizeGuide;
    this.brandList = this.createBrandList(sizeChart) || [];
    let curentBrand = sizeChart.length ? sizeChart[0].BRAND_NAME : '';
    const newDesignLuxe = this.props.newDesignLuxe;
    let ruler = `${properties.getProperty('imageBaseUrl')}/static/img/ruler.png`;
    let isRecommendedSize = false;
    let sizeData = '10';
    let { showLink } = this.state;
    {
      /* <div>
        <div className="size-guide-text" onClick={(e) => {
            this.closeModal(e);
        }}><span className="ic-scale-img"></span>Size Guide &nbsp;{this.brandList.length>0?<span className="new-label">NEW</span>:null}
          {this.brandList.length>0?<p className="brandcompare-pdp-txt">{`Compare ${curentBrand} size with other brand sizes`}</p>:''}
        </div>
        { !app ? <Modal name={"size-guide-modal"} className={"size-guide-modal"}>{this.renderData()}</Modal> : this.renderData()}
      </div> */
    }
    return (
      <div>
        {sizeRecommendData &&
        sizeRecommendData.hasOwnProperty('sizeName') &&
        sizeRecommendData.sizeName &&
        sizeRecommendData.sizeName.length > 0 ? (
          <InView
            as="div"
            threshold={0.5}
            triggerOnce
            onChange={() => {
              gtmEventPush({
                page_type: 'pdp screen',
                event: 'size_chart_interaction',
                category: 'product details interactions',
                action: 'select size view'
              });
            }}
          >
            <div className="size-guide-recom-container">
              {/* Image Section */}
              <div className="size-guide-image">
                {/* <img src="https://assets.ajio.com/medias/sys_master/root/h15/h13/12916169703454/-78Wx98H-440939494-blue-MODEL.jpg" alt="size" /> */}
                <img src={replaceWithJioCDN(sizeRecommendData.imageUrl)} alt="size" />
              </div>

              <div className="size-guide-com">
                {/* Size Guide Text */}
                <div className="size-guide-recomd-text">
                  <p>
                    Size <span className="size-recom"> {sizeRecommendData.sizeName} </span> is
                    recommended based on your previous purchase.
                  </p>
                  {/* <p>Size <span className="size-recom"> M </span> is recommended based on your previous purchase.</p> */}
                </div>

                {/* Size guide button */}
                <div
                  className="size-guide-recomd-text-link"
                  onClick={e => {
                    this.closeModal(e);
                  }}
                    role='button'
                    tabIndex={0}
                    onKeyDown={(event) => {
                      console.log("here ==>", event);
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault(); // Prevent default action
                        event.stopPropagation(); // Stop bubbling up
                        this.closeModal(event); // Ensure function is called
                      }
                    }}
                >
                  {newDesignLuxe ? (
                    <>
                      <img src={ruler} alt="Size chart icon" title="" />
                      <span>Size Chart&nbsp;</span>
                    </>
                  ) : (
                    <>
                      <span className="ic-scale-img" />
                      <span>Check Size Chart&nbsp;</span>
                    </>
                  )}
                  {this.brandList.length > 0 ? (
                    <span className="new-label" onClick={this.handlePropagation}>
                      {' '}
                      NEW{' '}
                    </span>
                  ) : null}

                  {this.brandList.length > 0 && brandCompare ? (
                    <p className="brandcompare-pdp-txt" onClick={this.handlePropagation}>Compare AJIO size with other brands</p>
                  ) : (
                    ''
                  )}
                </div>
                {sizeRecommendationPrimeAILinkFlag &&
                  this.setRecommendedSizeLink(isRecommendedSize, sizeData, newDesignLuxe, showLink)}
              </div>

              {!app ? (
                  <Modal ariaLabel="Size Chart" name="size-guide-modal" className="size-guide-modal">
                  {this.renderData()}
                </Modal>
              ) : (
                this.renderData()
              )}
            </div>
          </InView>
        ) : (
          <div className={newDesignLuxe ? 'luxe-size-guide-container' : ''} role="presentation">
            <div
              className="size-guide-text"
              onClick={e => {
                this.closeModal(e);
              }}
              tabIndex={0}
              role='button'
            >
              {newDesignLuxe ? (
                <img src={ruler} alt="Size chart icon" title="" />
              ) : (
                <span className="ic-scale-img" />
              )}
              {newDesignLuxe ? (
                <span >Size Chart&nbsp;</span>
              ) : (
                <InView
                  as="div"
                  threshold={0.5}
                  triggerOnce
                  onChange={inView => {
                    if (inView) {
                      gtmEventPush({
                        page_type: 'pdp screen',
                        event: 'size_chart_interaction',
                        category: 'product details interactions',
                        action: 'select size view'
                      });
                    }
                  }}
                >
                  <span>
                    Check Size Chart&nbsp;{' '}
                    {this.brandList.length > 0 ? <span className="new-label">NEW</span> : null}{' '}
                    {this.brandList.length > 0 && brandCompare ? (
                      <p
                        className="brandcompare-pdp-txt"
                      >
                        Compare AJIO size with other brands
                      </p>
                    ) : (
                      ''
                    )}
                  </span>
                </InView>
              )}
            </div>
            {sizeRecommendationPrimeAILinkFlag &&
              this.setRecommendedSizeLink(isRecommendedSize, sizeData, newDesignLuxe, showLink)}
            {!app ? (
                <Modal ariaLabel="Size Chart" name="size-guide-modal" className="size-guide-modal">
                {this.renderData()}
              </Modal>
            ) : (
              this.renderData()
            )}
          </div>
        )}
      </div>
    );
  }
}

class Table extends React.Component {
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.state = {
      isRadioTable: false,
    };
  }

  componentDidMount() {
    this.initializeRadioTable();
  }


  initializeRadioTable() {
    const table = this.tableRef.current;
    if (!table) return;

    const rows = Array.from(table.querySelectorAll("tbody tr"));
    if (rows.length === 0) return;

    // 1. Check if every row contains a radio
    const isRadioTable = rows.every(row =>
      row.querySelector('input[type="radio"]')
    );

    if (!isRadioTable) {
      if (this.state.isRadioTable) {
        this.setState({ isRadioTable: false });
      }
      return;
    }

    // Collect column headers
    const headers = Array.from(
      table.querySelectorAll("thead th")
    ).map(th => th.textContent.trim());

    // Collect radios
    const allRadios = Array.from(
      table.querySelectorAll('input[type="radio"]')
    );

    const enabledRadios = allRadios.filter(radio => !radio.disabled);

    if (enabledRadios.length === 0) {
      // Nothing focusable
      return;
    }

    // 2. Build aria-label for each radio
    rows.forEach(row => {
      const cells = Array.from(row.querySelectorAll("td"));
      const radio = row.querySelector('input[type="radio"]');
      if (!radio) return;

      const labelParts = cells.map((cell, index) => {
        const header = headers[index] || `Column ${index + 1}`;
        const value = cell.textContent.trim();
        return `${header}: ${value}`;
      });

      radio.setAttribute("aria-label", labelParts.join(", "));
    });

    // 3. Roving tabindex initialization (enabled radios only)
    let checkedRadio = enabledRadios.find(r => r.checked);

    if (!checkedRadio) {
      checkedRadio = enabledRadios[0];
      checkedRadio.checked = true;
    }

    enabledRadios.forEach(radio => {
      radio.tabIndex = radio === checkedRadio ? 0 : -1;
      radio.ariaHidden = radio === checkedRadio ? false : true;
      radio.removeEventListener("keydown", this.onRadioKeyDown);
      radio.addEventListener("keydown", this.onRadioKeyDown);
    });

    // Disabled radios must never be focusable
    allRadios
      .filter(r => r.disabled)
      .forEach(r => {
        r.tabIndex = -1;
        r.ariaHidden = "true";
        r.removeEventListener("keydown", this.onRadioKeyDown);
      });

    if (!this.state.isRadioTable) {
      this.setState({ isRadioTable: true });
    }
  }

  onRadioKeyDown = (event) => {
    const table = this.tableRef.current;
    if (!table) return;

    const enabledRadios = Array.from(
      table.querySelectorAll('input[type="radio"]:not(:disabled)')
    );

    const currentIndex = enabledRadios.indexOf(event.target);
    if (currentIndex === -1) return;

    let nextIndex;

    switch (event.key) {

      case "ArrowRight":
      case "ArrowDown":
        nextIndex = (currentIndex + 1) % enabledRadios.length;
          event.preventDefault();
        break;

      case "ArrowLeft":
      case "ArrowUp":
          event.preventDefault();
        nextIndex =
          (currentIndex - 1 + enabledRadios.length) %
          enabledRadios.length;
            event.preventDefault();
        break;

      case " ":
      case "Enter":
        event.target.click()
        event.target.checked = true;
     
        return;

      default:
        return;
    }

    const nextRadio = enabledRadios[nextIndex];

    enabledRadios.forEach(r => (r.tabIndex = -1));
    nextRadio.tabIndex = 0;
    nextRadio.checked = true;
    nextRadio.focus();

  };

  render() {
    const { tableConfig } = this.props;
    const { isRadioTable } = this.state;

    return (
      <table
        ref={this.tableRef}
        role={isRadioTable ? "radiogroup" : undefined}
      >
        <thead>
          <tr>{tableConfig.columns}</tr>
        </thead>
        <tbody>{tableConfig.rows}</tbody>
      </table>
    );
  }
}


function mapStateToProps(state) {
  const { flags = {} } = state;
  return {
    sizeRecommendationPrimeAILinkFlag: flags.sizeRecommendationPrimeAILinkFlag,
    brandCompare: getBrandCompare(state),
    howToMeasureVisibleInSizeGuideFlag: getHowToMeasureVisibleInSizeGuideFlag(state),
    selectedSizeName: state.product.selectedSizeName,
    howToMeasureNewImagesFlag: getHowToMeasureNewImagesFlag(state),
    howToMeasureNewImagesProducts: getHowToMeasureNewImagesProducts(state),
    productCategory: getProductCategory(state),
    productSubCategory: getProductSubCategory(state),
    brickName: getBrickName(state)
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    selectSize: (sizeName, sizeCode, stockLevel, discountPrice, originalPrice) => {
      generateEvent({
        Event: 'SizeSelection',
        value: {
          SizeSelectionValue: sizeName
        }
      });
      dispatch(selectSize(sizeName, sizeCode, stockLevel, discountPrice, originalPrice));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SizeGuide);
